/* eslint-disable @typescript-eslint/no-explicit-any */
import { useEffect, useRef } from 'react';

import { useTechSupportMode } from '@app/providers/TechSupportMode/useTechSupportMode';

const isEditableTarget = (target: EventTarget | null): boolean => {
  const el = target as HTMLElement | null;
  if (!el) return false;

  const tag = el.tagName?.toLowerCase();
  return tag === 'input' || tag === 'textarea' || el.isContentEditable;
};

export const useTechSupportModeHotkey = (options?: {
  enableOnly?: boolean;
}) => {
  const { toggle, setEnabled } = useTechSupportMode();
  const lastHitAtRef = useRef<number>(0);

  useEffect(() => {
    const onKeyDown = (event: KeyboardEvent) => {
      if (isEditableTarget(event.target)) return;

      const isMatch =
        event.code === 'KeyT' &&
        event.shiftKey &&
        event.altKey &&
        (event.ctrlKey || event.metaKey);

      if (!isMatch) return;

      event.preventDefault();

      const now = Date.now();
      const last = lastHitAtRef.current;
      lastHitAtRef.current = now;

      if (now - last > 800) return;

      if (options?.enableOnly) setEnabled(true);
      else toggle();

      lastHitAtRef.current = 0;
    };

    window.addEventListener('keydown', onKeyDown, { capture: true });
    return () =>
      window.removeEventListener('keydown', onKeyDown, {
        capture: true,
      } as any);
  }, [toggle, setEnabled, options?.enableOnly]);
};
